import React from "react"
export function CrossOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm2.47 3.47l1.06 1.06L11.06 10l2.47 2.47-1.06 1.06L10 11.062l-2.47 2.47-1.06-1.06L8.939 10l-2.47-2.47L7.53 6.47 10 8.939l2.47-2.47z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__cross---outline"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
